import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { encodeOpenMetadataFqnSafe } from '@/shared/lib/format';
import type { TagLabel } from '@/shared/types';

export type ColumnData = {
  name: string;
  dataType: string;
  dataLength?: number;
  dataTypeDisplay: string;
  description?: string;
  fullyQualifiedName: string;
  tags?: TagLabel[];
  constraint?: string;
  children?: ColumnData[];
};

export type ColumnResponse = {
  data: ColumnData[];
  paging: {
    total: number;
  };
};

export const fetchColumns = async (fullyQualifiedName: string): Promise<ColumnResponse> => {
  const encodedFqn = encodeOpenMetadataFqnSafe(fullyQualifiedName);
  const response = await openMetadataApiClient.get<ColumnResponse>(`/tables/name/${encodedFqn}/columns`, {
    params: {
      offset: 0,
      limit: 50,
      include: 'all',
    },
  });

  return response.data;
};
